import _find from 'lodash/find';
import _size from 'lodash/size';
import _get from 'lodash/get';
import _each from 'lodash/each';
import _compact from 'lodash/compact';
import _reduce from 'lodash/reduce';
import {batch} from 'react-redux';
import {translation, decimal} from 'utilsHelper.js';
import {startInterval, stopInterval} from 'intervalActions.js';
import {
    calculateWinning,
    changeSlipTotalStake,
    changeSlipStake,
    placeBetSlipSuccess,
    clearBetslip,
    refreshOddsByOutcomeId
} from 'betSlipActions.js';

export const UPDATE_APPROVAL_DATA = 'UPDATE_APPROVAL_DATA';
export const BIND_APPROVAL_BUTTONS = 'BIND_APPROVAL_BUTTONS';
export const REJECT_APPROVAL_DATA = 'REJECT_APPROVAL_DATA';
export const ACCEPT_APPROVAL_DATA = 'ACCEPT_APPROVAL_DATA';
export const SHOW_APPROVAL_MESSAGE = 'SHOW_APPROVAL_MESSAGE';

const loadApprovalDataOnInit = () => {
    return (dispatch, getState) => {
        dispatch(startIntervalFetchApprovedSlips());
    }
};

const startIntervalFetchApprovedSlips = () => {
    return (dispatch, getState) => {
        const config = {
            key: 'FETCH_APPROVAL_SLIPS',
            actionCreator: fetchApprovedSlips,
            timeout: 10000
        };
        setTimeout(() => {
            dispatch(startInterval(config));
        }, process.env.FETCH_APPROVED_SLIPS_TIMEOUT);
    }
};

const stopIntervalFetchApprovedSlips = () => {
    return (dispatch, getState) => {
        const key = 'FETCH_APPROVAL_SLIPS';
        const {Intervals:{intervals}} = getState();
        const intervalExist = _find(intervals, {key});
        if (_size(intervalExist)) {
            dispatch(stopInterval(key));
        }
    }
};

const bindApprovalButtons = () => {
    return {type: BIND_APPROVAL_BUTTONS}
};

const acceptApprovalData = (msg = ``) => {
    return (dispatch) => {
        dispatch({type: ACCEPT_APPROVAL_DATA});
        dispatch(placeBetSlipSuccess());
        dispatch(showApprovalMessage(msg));
    };
};

const rejectApprovalData = (msg = ``) => {
    return (dispatch) => {
        dispatch({type: REJECT_APPROVAL_DATA});
        dispatch(clearBetslip());
        dispatch(showApprovalMessage(msg));
    };
};

const showApprovalMessage = (msg = ``) => {
    return {type: SHOW_APPROVAL_MESSAGE, payload: {msg}}
};

const updateApprovalData = (approvalData) => {
    return {type: UPDATE_APPROVAL_DATA, payload: {approvalData}};
};

const acceptTraderChanges = () => {
    return async(dispatch, getState, {BettingApi}) => {
        try {
            const {code, data} = await BettingApi.acceptTraderChanges();
            if (code != 200) {
                throw {message: translation(`m_approvalChangeError`)};
            }
            const msg = translation(`approvalChanged_1`);
            dispatch(acceptApprovalData(msg));

            return data;
        } catch ({message}) {
            throw message;
        }
    }
};

const rejectTraderChanges = () => {
    return async(dispatch, getState, {BettingApi}) => {
        try {
            const {code, data} = await BettingApi.rejectTraderChanges();
            if (code != 200) {
                throw {message: translation(`m_approvalChangeError`)};
            }
            const msg = translation(`approvalChanged_10`);
            dispatch(rejectApprovalData(msg));

            return data;
        } catch ({message}) {
            throw message;
        }
    }
};

const showApprovalStakeAndOddsChange = (msg = ``) => {
    return (dispatch) => {
        dispatch(showApprovalStakeChange());
        dispatch(showApprovalOddsChange());
        dispatch(showApprovalMessage(msg));
    }
};

const showApprovalStakeChange = () => {
    return (dispatch, getState) => {
        const {BetSlip:{approvalData:{newStake}}} = getState();
        dispatch({type: 'SHOW_APPROVAL_STAKE_CHANGE'});
    }
};

const showApprovalOddsChange = () => {
    return (dispatch, getState) => {
        const {BetSlip:{approvalData:{oddsChanges}}} = getState();
        const oddsChangesParts = _compact(oddsChanges.split('|'));
        const preparedOddsChange = _reduce(oddsChangesParts, (initialObject, nextElement) => {
            const [outcomeId, prevOdds, outcomeOdds] = nextElement.split('_');
            return {...initialObject, [outcomeId]: {prevOdds, outcomeOdds}};
        }, {});

        batch(() => {
            _each(preparedOddsChange, ({prevOdds, outcomeOdds}, outcomeId) => {
                const params = {outcomeId, outcomeOdds, prevOdds};
                dispatch(refreshOddsByOutcomeId(params));
            });
        });
    }
};

const processApprovalChanges = () => {
    return (dispatch, getState) => {
        const {BetSlip:{approvalData:{status, newStake}, activeTab, betSlips}} = getState();
        const {slipType} = _get(betSlips, [activeTab]);

        if (status) {
            let msg = translation(`approvalChanged_${status}`);
            switch (status) {
                case 1:
                    dispatch(acceptApprovalData(msg));
                    break;
                case 10:
                    dispatch(rejectApprovalData(msg));
                    break;
                case 2:
                    dispatch(showApprovalStakeChange());
                    dispatch(showApprovalMessage(msg));
                    break;
                case 3:
                    dispatch(showApprovalOddsChange());
                    dispatch(showApprovalMessage(msg));
                    break;
                case 4:
                    dispatch(showApprovalStakeAndOddsChange(msg));
                    break;
            }

            // odds lub odds i stawka
            if ([2, 3, 4].indexOf(status) != -1) {
                dispatch(bindApprovalButtons());
            }

            if ([2, 4].indexOf(status) != -1 && newStake) {
                if (slipType == 'SYSTEM') {
                    dispatch(changeSlipTotalStake(newStake));
                } else {
                    dispatch(changeSlipStake(newStake));
                }
            }

            if ([2, 3, 4].indexOf(status) != -1) {
                dispatch(calculateWinning());
            }
        }
    }
};

const fetchApprovedSlips = () => {
    return async(dispatch, getState, {BettingApi}) => {
        try {
            const {BetSlip:{approvalData}} = getState();
            const {creationDate, slipId} = approvalData;
            const {code, data} = await BettingApi.fetchApprovedSlips();

            if (_size(data)) {
                if (slipId == data.slipId) {
                    switch (data.status) {
                        case 1:
                        case 10:
                            // 1: zaakceptowany, 10: odrzucony
                            dispatch(stopIntervalFetchApprovedSlips());
                            dispatch(updateApprovalData(data));
                            break;
                        case 2:
                        case 3:
                        case 4:
                            // zmiana stawki, oddsów, obu naraz
                            dispatch(stopIntervalFetchApprovedSlips());
                            dispatch(updateApprovalData(data));
                            break;
                    }
                }
            } else {
                const now = new Date();
                const expireOffsetMillis = 180000;
                if (creationDate + expireOffsetMillis < now.getTime()) {
                    const data = {status: 10};
                    dispatch(stopIntervalFetchApprovedSlips());
                    dispatch(updateApprovalData(data));
                }
            }

            dispatch(processApprovalChanges());

        } catch (error) {
            console.log({error});
        }
    }
};

export {
    loadApprovalDataOnInit,
    startIntervalFetchApprovedSlips,
    stopIntervalFetchApprovedSlips,
    acceptTraderChanges,
    rejectTraderChanges
}